// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"3004572f","213":"72a5c661","667":"5fea9342"}[chunkId] + ".chunk.js";
};